import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class ApiUrlConstant {

  // overall status dashboard
  OVERALL_STATUS_REGION_WISE = '/at/e2e/order-status/shipment/region-status/group?page_number=0';
  PAGE_WIDGET_DATA = "/e2e/v1/client/widget";
  mostAffectedChild = "p-d-affected-states.json";
  mostAffecteedCustomers = "p-d-affected-customers.json";

  returnWorstODPairs = "p-t-worst-od-pairs.json";
  mostAffectedWOrstODPairsTransportation = "p-transportation-od-pairs.json";
  transportWarehouseUtilization =
    "p-d-transportation-warehouse-utilization.json";
  transportTemperatureAdherence =
    "p-d-transportation-temperature-adherence.json";
  getOverallOtif = "/03/e2e/otif/overall";

  GET_DELIVERY_END_2_END_SLA = "/06/e2e/otif/region-wise";

  DELHIVERY_PERFORMANCE_OVERALL_TREND = "/04/e2e/otif/trend";

  DELHIVERY_PERFORMANCE_OVERALL_TREND_REASON_FAILURE = "/05/e2e/otif/failure";

  regionWiseOtifBreakup = "/06/e2e/otif/region-wise";

  DELHIVERY_PERFORMANCE_MOST_AFFECTED_STATES = "/07/e2e/otif/affected-states";

  DELHIVERY_PERFORMANCE_MOST_AFFECTED_CUSTOMERS = "/08/e2e/otif/affected-customer";

  DELHIVERY_PERFORMANCE_YESTERDAY_OTIF_HIGHLIGHT = "/00/e2e/otif/yesterday";

  DELHIVERY_PERFORMANCE_MONTH_OTIF_HIGHLIGHT = "/01/e2e/otif/month-to-date";

  DELHIVERY_PERFORMANCE_QUARTER_OTIF_HIGHLIGHT = "/02/e2e/otif/quarter-to-date";

  //end delivery

  OVERALL_PERFORMANCE_TRANSFER_E2E_SLA = "/113/e2e/transfer/sla/end-to-end";

  OVERALL_PERFORMANCE_TRANSFER_E2E_SLA_TRENDS =
    "/14/e2e/transfer/sla/end-to-end/trend";

  OVERALL_PERFORMANCE_TRANSFER_REASON_FAILURE = "/15/e2e/transfer/reason-for-failure";

  OVERALL_PERFORMANCE_TRANSFER_WORST_OD_PAIRS = "/16/e2e/transfer/worst-o-d-pair";

  OVERAL_PERFORMANCE_TRANSFER_YESTERDAY_SLA_HIGHLIGHT =
    "/10/e2e/transfer/sla/yesterday";

  OVERAL_PERFORMANCE_TRANSFER_MONTH_SLA_HIGHLIGHT =
    "/11/e2e/transfer/sla/month-to-date";

  OVERAL_PERFORMANCE_TRANSFER_QUARTER_SLA_HIGHLIGHT =
    "/12/e2e/transfer/sla/quarter-to-date";

  //end transfer

  OVERALL_PERFORMANCE_INWARD_E2E_SLA = "/21/e2e/inward/sla/end-to-end";

  OVERALL_PERFORMANCE_INWARD_E2E_SLA_TRENDS = "/22/e2e/inward/sla/end-to-end/trend";

  OVERALL_PERFORMANCE_INWARD_REASON_FAILURE = "/23/e2e/inward/reason-for-failure";

  OVERALL_PERFORMANCE_INWARD_WORST_OD_PAIRS = "/24/e2e/inward/worst-o-d-pair";

  OVERAL_PERFORMANCE_INWARD_YESTERDAY_SLA_HIGHLIGHT = "/18/e2e/inward/sla/yesterday";

  OVERAL_PERFORMANCE_INWARD_MONTH_SLA_HIGHLIGHT = "/19/e2e/inward/sla/month-to-date";

  OVERAL_PERFORMANCE_INWARD_QUARTER_SLA_HIGHLIGHT =
    "/20/e2e/inward/sla/quarter-to-date";
  //end inward

  OVERALL_PERFORMANCE_RETURN_E2E_SLA = "/29/e2e/returns/sla/end-to-end";

  OVERALL_PERFORMANCE_RETURN_E2E_SLA_TREND = "/30/e2e/returns/sla/end-to-end/trend";

  OVERALL_PERFORMANCE_RETURN_REASON_FAILURE = "/31/e2e/returns/reason-for-failure";

  OVERAL_PERFORMANCE_RETURN_YESTERDAY_SLA_HIGHLIGHT = "/26/e2e/returns/sla/yesterday";

  OVERAL_PERFORMANCE_RETURN_MONTH_SLA_HIGHLIGHT = "/27/e2e/returns/sla/month-to-date";

  OVERAL_PERFORMANCE_RETURN_WORST_OD_PAIRS = "/32/e2e/returns/worst-o-d-pair";


  OVERAL_PERFORMANCE_RETURN_QUARTER_SLA_HIGHLIGHT =
    "/28/e2e/returns/sla/quarter-to-date";
  FILTERS = {
    OVERALL_STATUS: '/overall-status-filters.json',
    OVERALL_PERFORMANCE_INWARD: "/inward-filters.json",
    OVERALL_PERFORMANCE_DELHIVERY: "/filters.json",
    OVERALL_PERFORMANCE_TRANSFER: "/otif-transfer-filters.json",
    OVERALL_PERFORMANCE_RETURNS: "/otif-returns-filters.json",
    WAREHOUSE_PERFORMANCE: "/warehouse-performance-filters.json",
    WAREHOUSE_OUTBOUND: "/warehouse-outbound.json",
    WAREHOUSE_INBOUND: "/warehouse-inbound.json",
    WAREHOUSE_PERFORMANCE_INVENTORY : "/warehouse-performance-inventory-filters.json",
    TRANSPORTATION_FILTERS: "/transportation-performance-filters.json",
    SALES_FORECAST_FILTERS: "/sales-forecast-filters.json",
    INVENTORY_DETAILS_FILTERS: "/inventory-details-filter.json",
    MOVEMENT_DETAILS_DELIVERY: "/movement-filter-delivery.json",
    MOVEMENT_DETAILS_TRANSFER: "/movement-filter-transfer.json",
    MOVEMENT_DETAILS_INWARD: "/movement-filter-inward.json",
    MOVEMENT_DETAILS_RETURNS: "/movement-filter-returns.json",
    PICKUP_REQUEST_LISTING: "/pickup-request-listing-filter.json"
  };
  //end returns

  //warehouse

  WAREHOUSE_MOST_AFFECTED_WAREHOUSES = "/39/e2e/warehouse/most-affected";
  WAREHOUSE_SLA = "/37/e2e/warehouse/sla";
  WAREHOUSE_SLA_TREND = "/38/e2e/warehouse/sla-trend";
  WAREHOUSE_UTILIZATION = "/40/e2e/warehouse/utilization";
  WAREHOUSE_DAMAGE = "/e2e/warehouse/damage"; // not in use right now
  WAREHOUSE_INVENTORY_AUDIT_ACCURACY = "/e2e/warehouse/inventory/audit/accuracy"; // not in use right now

  WAREHOUSE_YESTERDAY_HIGHLIGHT = "/34/e2e/warehouse/sla/yesterday";
  WAREHOUSE_MONTH_HIGHLIGHT = "/35/e2e/warehouse/sla/month-to-date";
  WAREHOUSE_QUARTER_HIGHLIGHT = "/36/e2e/warehouse/sla/quarter-to-date";

  WAREHOUSE_OUTBOUND_TRENDS = '/cb/e2e/warehouse/outbound/sla/trends'
  WAREHOUSE_OUTBOUND_HIGHLIGHTS = '/ca/e2e/warehouse/outbound/sla/highlights'
  WAREHOUSE_OUTBOUND_OVERALL_SLA = '/cl/e2e/warehouse/outbound/sla/overall'
  WAREHOUSE_OUTBOUND_REGIONAL_SLA = '/cc/e2e/warehouse/outbound/sla/region'
  WAREHOUSE_OUTBOUND_WORST_AFFECTED_WAREHOUSE = '/cd/e2e/warehouse/outbound/sla/fc';
  WAREHOUSE_OUTBOUND_BEST_PERFORMING_WAREHOUSE = '/cd/e2e/warehouse/outbound/sla/fc';


  WAREHOUSE_INBOUND_TRENDS = '/cf/e2e/warehouse/inbound/sla/trends'
  WAREHOUSE_INBOUND_HIGHLIGHTS = '/ce/e2e/warehouse/inbound/sla/highlights'
  WAREHOUSE_INBOUND_OVERALL_SLA = '/cg/e2e/warehouse/inbound/sla/overall'
  WAREHOUSE_INBOUND_REGIONAL_SLA = '/cg/e2e/warehouse/inbound/sla/region'
  WAREHOUSE_INBOUND_WORST_AFFECTED_WAREHOUSE = '/ch/e2e/warehouse/inbound/sla/fc';
  WAREHOUSE_INBOUND_MOST_AFFECTED_PRODUCT = '/ci/e2e/warehouse/inbound/sla/product-category';

  WAREHOUSE_INVENTORY_TREND = "/bx/e2e/warehouse/inventory/trends";
  WAREHOUSE_INVENTORY_FILL_RATE = "/by/e2e/warehouse/fill/rate";
  WAREHOUSE_INVENTORRY_ANALYSIS = "/bz/e2e/warehouse/product/category/analysis";
  //warehouse ends
  //Transportation
  TRANSPORTATION_SLA = "/45/e2e/transportation/sla";

  TRANSPORTATION_MAX_OD = "/47/e2e/transportation/sla-max-od";
  TRANSPORTATION_POD_AVAIL = "/49/e2e/transportation/pod-availability";
  TRANSPORTATION_POD = "/48/e2e/transportation/tat-breakup";
  TRANSPORTATION_SLA_TREND = "/cn/e2e/transportation/sla/trends";
  TRANSPORTATION_MOST_AFFECTED_OD = "/cp/e2e/transportation/sla/od-pairs";
  TRANSPORTATION_DELIVERY_ATTEMPT_SLA = "/co/e2e/transportation/sla/region";

  TRANSPORTATION_YESTERDAY_HIGHLIGHT = "/42/e2e/transportation/sla/yesterday";
  TRANSPORTATION_MONTH_HIGHLIGHT = "/43/e2e/transportation/sla/month-to-date";
  TRANSPORTATION_QUARTER_HIGHLIGHT = "/44/e2e/transportation/sla/quarter-to-date";
  //transportation end

  //Inventory Details

  INVENTORY_DETAILS_ALL = "/51/e2e/listing/inventory/all";
  INVENTORY_DETAILS_STORAGE = "/52/e2e/listing/inventory/storage";
  INVENTORY_DETAILS_PROCESSING = "/53/e2e/listing/inventory/processing";
  INVENTORY_DETAILS_TRANSIT = "/54/e2e/listing/inventory/transit";
  INVENTORY_DETAILS_HIGHLIGHTS = "";
  INVENTORY_DETAILS_DETAILS = "/55/e2e/listing/inventory/details";
  INVENTORY_DETAILS_CONDITIONS = "/89/e2e/config/user/client/inventory/condition";

  //Inventory Details Ends

  //Movement Details
  MOVEMENT_BULK_POD_DOWNLOAD = "/az/e2e/listing/movement/pod-download"
  MOVEMENT_DETAILS_ORDERS = "/63/e2e/listing/movement/order";
  MOVEMENT_DETAILS_INWARD = "/75/e2e/listing/movement/inward";
  MOVEMENT_DETAILS_ORDER_DETAILS = "/64/e2e/listing/movement/order/details";
  MOVEMENT_DETAILS_ORDER_LINES = "/65/e2e/listing/movement/orderlines";
  MOVEMENT_DETAILS_SHIPMENT = "/66/e2e/listing/movement/shipment";
  MOVEMENT_DETAILS_WAYBILL = "/67/e2e/listing/movement/waybill/orderline";
  MOVEMENT_DETAILS_WAYBILL_DETAILS = "/68/e2e/listing/movement/waybill/details";
  MOVEMENT_DETAILS_GET_DOCUMENT = "/69/e2e/listing/movement/fetch/document";
  MOVEMENT_AGN_DETAILS = "/72/e2e/listing/movement/agn/details";
  MOVEMENT_AGN_BATCHE = "/74/e2e/listing/movement/batches";
  MOVEMENT_AGN_BATCHE_PRODUCTS = "/73/e2e/listing/movement/batch-products";
  MOVEMENT_AGN_AWB_PRODUCTS = "/70/e2e/listing/movement/agn-waybill/batch-products";
  MOVEMENT_AGN_AWB_DETAILS = "/71/e2e/listing/movement/agn-waybill/details";

  //Movement Details Ends
  //start listing inventory
  INVENTORY_DETAILS_TAB_ALL_VALUE = "/56/e2e/listing/inventory/value";
  INVENTORY_DETAILS_TAB_ALL = "/51/e2e/listing/inventory/all";
  INVENTORY_DETAILS_TAB_PROCESSING = "/53/e2e/listing/inventory/processing";
  INVENTORY_DETAILS_TAB_STORAGE = "/52/e2e/listing/inventory/storage";
  INVENTORY_DETAILS_TAB_TRNSIT = "/54/e2e/listing/inventory/transit";

  //end listing inventory
  GET_USER_CLIENTS = "/76/e2e/config/user/client";

  GET_USER_PROFILE = "/85/e2e/config/user/profile"; // not in use right now

  //Sales forecast
  GET_SALES_FORECAST_AREA = "/86/e2e/user/mappings";	
  GET_N_SALES_FORECAST = "/99/e2e/forecast/client/forecasting-mapping";
  GET_SALES_FORECAST_LIST = "/92/e2e/forecast/client/forecasting/month";
  POST_SALES_FORECAST_LIST = "/93/e2e/forecast/client/forecasting/month";
  GET_FORECAST_CUTOFF = "/98/e2e/forecast/client/forecasting-cutoff";
  GET_SALES_HISTORY_DOWNLOAD = "/94/e2e/forecast/client/sales-forecasting/history";
  SALESFORECAST_UPLOAD_CSV_FILE = "/95/e2e/forecast/client/sales-forecasting/csv";
  POST_SALESFORECAST_UPLOAD_CSV_FILE = "/96/e2e/forecast/client/sales-forecasting/csv";
  REQUEST_TRACKER_URL = "/ac/e2e/request-tracker/logs";
  REQUEST_TRACKER_URL_ENTITY = "";	
  GET_SALES_FORECAST_FACILITY_AREA = "/86/e2e/config/filter/facility/area";
  UPLOAD_RTS_CONSENSUS = "/ba/e2e/forecast/client/rtf-consensus/csv";
  DOWNLOAD_RTS_CONSENSUS = "/bb/e2e/forecast/client/rtf-consensus/csv";

  VALID_FILTERS = "/97/e2e/filters/valid-filters";

  OTIF_REPORT_DOWNLOAD_URL = '/09/e2e/otif/report';
  INWARD_REPORT_DOWNLOAD_URL = '/25/e2e/inward/sla/report';
  RETURN_REPORT_DOWNLOAD_URL = '/33/e2e/returns/sla/report';
  TRANSFER_REPORT_DOWNLOAD_URL = '/17/e2e/transfer/sla/report';
  WAREHOUSE_SLA_REPORT_DOWNLOAD_URL = '/41/e2e/warehouse/sla/report';

  //Google URLs
  
  LAT_LON_MAP = 'https://www.google.com/maps/search/?api=1&query='

  OVERALL_STATUS_STATUS_TREND = '/au/e2e/order-status/shipment/status/trend';
  OVERALL_STATUS_CUMULATIVE_STATUS = '/as/e2e/order-status/shipment/status/group';
  HIGHLIGH_OVERALL_STATUS = {
    YESTERDAY: '/as/e2e/order-status/shipment/status/group',
    CURRENT_MONTH: '/as/e2e/order-status/shipment/status/group',
    OVERVIEW: '/as/e2e/order-status/shipment/status/group'
  };
  //Overall Status
  REGION_WISE_STATUS = "/at/e2e/order-status/shipment/region-status/group";
  STATUS_BREAKUP = "/av/e2e/order-status/shipment/interval-status/group";
  OVERVIEW_STATUS_TREND = "/au/e2e/order-status/shipment/status/trend";
  TREND_AT_GLANCE = "/ck/e2e/order-status/inbound-outbound/status/trend";

  //pickup request 
  PICKUP_REQUEST_LISTING = '/ag/e2e/pickup-request/pickup';
  CREATE_EDIT_BASIC_INFORMATION = '/pickup-create-edit-basic-information.json';
  PICKUP_LISTING_AGGREGATION = '/al/e2e/pickup-request/pickup/aggregation';
  CREATE_REQUEST_PICKUP_FIELD_API = '/80/e2e/config/filter/facility/type';
  ORIGIN_API = '/81/e2e/config/filter/facility/name';
  TRUCK_LIST_API = '/ai/e2e/pickup-request/truck-type';
  ORIGIN_API_V2 = '/81/e2e/config/filter/facility/name/v2';
  GETUSER_DETAILS = '/cm/e2e/pickup-request/user-detail';
  //TRUCK_LIST_API = '/aj/e2e/pickup-request/truck';
  PICKUP_DETAIL = '/ah/e2e/pickup-request/pickup';
  PICKUP_CANCEL = '/am/e2e/pickup-request/pickup/cancel';
  PICKUP_APPROVE = '/an/e2e/pickup-request/pickup/approve';
  MODE_LIST_API = '/mode_list.json';
  CREATE_PICKUP_REQUEST = '/af/e2e/pickup-request/pickup';
  EDIT_PICKUP_REQUEST = '/ak/e2e/pickup-request/pickup';
  START_DISPATCH_PICKUP_REQUEST = '/ao/e2e/pickup-request/pickup/dispatch/';
  SHIPMENT_DISPATCH = "/ap/e2e/pickup-request/shipment/dispatch/";
  SHIPMENT_CANCEL = "/aq/e2e/pickup-request/shipment/cancel";
  FILE_DOWNLOAD = "/ar/e2e/pickup-request/shipment/invoice-download";
  TRUCK_SIZE_LIST = "/aj/e2e/pickup-request/truck";
  QTY_IN_DESTINATION = "/bc/e2e/pickup-request/container/search";
  REASON_FOR_ON_HOLD_LIST = "/reason-for-on-hold.json";
  REASON_FOR_ON_HOLD = "/cj/e2e/pickup-request/pickup/hold";
  BULK_UPLOAD = "/cq/e2e/pickup-request/bulk-pickup";
  ORIGIN_LOCATIONS = "/81/e2e/config/filter/facility/name";
  DESTINATION_LOCATIONS = "/81/e2e/config/filter/facility/name/v2";

  //user list permissions
  ORIGIN_TYPE = "/80/e2e/config/filter/facility/type";
  BUSINESS_DIVISION = "/78/e2e/config/filter/business-division";
  PRODUCT_FILTER = "/79/e2e/config/filter/product-category";
  REGION = "/82/e2e/config/filter/facility/region";
  AREA = "/86/e2e/config/filter/facility/area";
  UMS_USERS_LIST = "/v2/client-user/";
  CREATE_USER = "/v2/client-user/";
  GET_ASSIGEND_ROLES = "/v2/client-user-roles/";
  DELETE_ROLES = "/v2/client-user-roles/";
  CLIENT_DATA = "/aw/e2e/config/client/data";
  USER_DATA = "/ax/e2e/config/user/data/v2";
  UPDATE_USER_WISE = "/ay/e2e/config/user/data";
  GET_UMS_ROLES = "/v2/roles/";
  ASSIGN_UMS_ROLE = "/user_roles/";
  UNASSIGN_UMS_ROLE = "/user_roles/";
  USER_UMS_ROLES = "/user_roles/";
  UMS_USERS_V3 = "/v3/users/";
  GET_SELF_SCOPES = "/user_roles/self/";

   //Fresh Desk API

  GET_ALL_DATA = "/az/e2e/fresh-desk/tickets/list";
  GET_SELF_PROFILE = "/v2/users/self/";
  LOGIN_BY_USERNAME_PASSWORD = "/login/";
  FORGOT_PASSWORD = '/v2/forgot-password/';
  MAKE_CLIENT_SUPER_ADMIN = "/bd/e2e/config/user/superuser";

  CLIENT_DETAILS = "/bq/e2e/config/client/details/";
  FACILITY_LISTING = "/bg/e2e/config/client/facility/";
  FACILITY_CSV = "/bl/e2e/config/client/facility/csv/";
  FACILITY_CSV_UPLOAD = "/bu/e2e/config/client/facility/csv/";
  PRODUCT_DIVISION_LISTING = "/bh/e2e/config/client/product/division/";
  PRODUCT_DIVISION_CSV = "/bm/e2e/config/client/product/division/csv/";
  PRODUCT_DIVISION_CSV_UPLOAD = "/bv/e2e/config/client/product/division/csv/";
  EDIT_CLIENT_UMS_ID = "/br/e2e/config/client/ums/id";
  OVERALL_STATUS_AREA_WISE = '/be/e2e/order-status/shipment/area-status/group?page_number=0';
  OVERALL_STATUS_WAREHOUSE_WISE = '/bf/e2e/order-status/shipment/warehouse-status/group?page_number=0';

  //Reports Download
  CHANNEL_LIST_API = "/bt/e2e/autocomplete/channel";
  DOWNLOAD_REPORTS = "/bs/e2e/report/generate-report";
}
